/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.37.0
 * @since 1.37.0
 */

import { EBasketType } from '@modules/app/appConstants';
import { EBreadCrumbType } from '@modules/breadCrumbs/breadCrumbsTypes';

import { IWizardRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const WizardChangeRoleRouteConfiguration: IWizardRouterConfiguration[] = [
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.wizardChangeRole,
        ],
        path: RoutePath.wizardChangeRoleFromSubscribers,
    },
    {
        basketType: EBasketType.MOBILE,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.subscriberMobileInfo,
            EBreadCrumbType.wizardChangeRole,
        ],
        path: RoutePath.wizardChangeRoleFromSubscriberId,
    },
];
